// @flow

import ReduceStore from 'PMT/flux/ReduceStore';
import _ from 'lodash';

// -- constant
import Events from 'constants/Events';
import ActionTypes from 'constants/ActionTypes';

// -- entity
import ApiError from 'PMT/entities/ApiError';
import User from 'PMT/entities/user/User';

class UserStore extends ReduceStore {

  getInitialState() {
    return {
      /**
       * @type ApiError
       */
      apiError: null,

      /**
       * @type User
       */
      user: null,
    }
  }

  isEmitingCustomEvents(): boolean {
    return true;
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      user: new User(),
    }
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getUser(): User {
    return this._state.user;
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      case ActionTypes.GET_USER_RESPONSE_SUCCESS:
        nextState.user = action.user;
        nextState.apiError = null;

        this.emitEvent(Events.ON_LOADING_USER);
        return nextState;

      case ActionTypes.GET_USER_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;

        this.emitEvent(Events.ON_LOADING_USER_ERROR);
        return nextState;

      default:
        return nextState;
    }
  }

}

export default new UserStore();
